import { GoogleGenerativeAI } from "@google/generative-ai";
import ModelClient, { isUnexpected } from "@azure-rest/ai-inference";
import { AzureKeyCredential } from "@azure/core-auth";

const genAI = new GoogleGenerativeAI(process.env.REACT_APP_PORTFOLIO_AI_API_KEY);

const token = process.env.REACT_APP_PORTFOLIO_AI_API_KEY;
const endpoint = "https://models.github.ai/inference";
const model = "openai/gpt-4.1-nano";

const contentConfiguration = {
    stopSequences: ["red"],
    maxOutputTokens: 100,
};

const useGeminiAi = (props) => {
    const { text, image } = props;

    if (text && !image) {
        return geminiTextModal(text);
    } else if (text && image) {
        return geminiImageModal(text, image);
    } else if (!text && image) {
        return geminiImageModal("What do you think about this image?", image);
    }
};

const fallBackModel = async (textPrompt) => {
    try {
        const client = ModelClient(endpoint, new AzureKeyCredential(token));

        const response = await client.path("/chat/completions").post({
            body: {
                messages: [{ role: "user", content: textPrompt }],
                temperature: 1,
                top_p: 1,
                model: model,
            },
        });

        if (isUnexpected(response)) {
            throw response.body.error;
        }

        return {
            responseReceived: true,
            responseData: response.body.choices[0].message.content,
        };
    } catch (err) {
        return {
            responseReceived: false,
            responseData: err,
        };
    }
};

const geminiTextModal = async (textPrompt) => {
    return fallBackModel(textPrompt);

    const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash", contentConfiguration });

    try {
        const result = await model.generateContent(textPrompt);
        const response = result.response;
        const text = response.text();

        return {
            responseReceived: true,
            responseData: text,
        };
    } catch (err) {
        return {
            responseReceived: false,
            responseData: err,
        };
    }
};

const geminiImageModal = async (textPrompt, imagePrompt) => {
    const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" }); // for text-and-images input (multimodal), use the gemini-1.5-flash model

    try {
        const prompt = textPrompt;

        const fileInputEl = document.querySelector("input[type=file]");

        const imageParts = await Promise.all(
            [...fileInputEl.files].map((data) => {
                return fileToGenerativePart(data);
            })
        );

        // converts a file object to a GoogleGenerativeAI.Part object
        async function fileToGenerativePart(file) {
            const base64EncodedDataPromise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(",")[1]);
                reader.readAsDataURL(file);
            });

            return {
                inlineData: { data: await base64EncodedDataPromise, mimeType: file.type },
            };
        }

        const result = await model.generateContent([prompt, ...imageParts]);
        const response = result.response;
        const text = response.text();

        return {
            responseReceived: true,
            responseData: text,
        };
    } catch (err) {
        return {
            responseReceived: false,
            responseData: err,
        };
    }
};

export default useGeminiAi;
